import {
  sanitizeTelemetryText,
  sanitizeTelemetryValue,
} from './integrations/gmail/gmailAttemptVault';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import Button from '@components/common/button/Button';

interface IErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
  onError: (error: Error, errorInfo: ErrorInfo) => void;
}

interface IErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {

  public static getDerivedStateFromError = (error: Error): IErrorBoundaryState => ({
    hasError: true,
    error,
  });

  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  public componentDidCatch = (error: Error, errorInfo: ErrorInfo): void => {
    try {
      // Keep the original Error (including its JS stack) and React component
      // stack together, using the same reporting path as global errors.
      this.props.onError(error, errorInfo);
    } catch (reportingError) {
      console.error('Failed to report React error:', sanitizeTelemetryValue(reportingError));
    }
  };

  public render(): ReactNode {
    if (this.state.hasError) {

      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong. Please screenshot and send to hello@co-parenting.app</h2>
          <p>{sanitizeTelemetryText(this.state.error?.message || '')}</p>
          <Button variant="contained" color="primary" onClick={this.handleReset}>Try Again</Button>
        </div>
      );
    }

    return this.props.children;
  }

  private handleReset = (): void => {
    this.setState({ hasError: false, error: null });
  };

}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/ErrorBoundary.tsx